export {
  default as general,
  ReactComponent as General,
} from '@assets/icons/features-and-amenities/general.svg'    
